<template>
    <section v-if="hasPermissions(['Census-Worksheet Read'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ `${title_page} of ${parent.description}` }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
            </p>
        </div>

        <div class="row bar__container">
            <div class="col-md-6 py-0 mb-3 mb-md-0">
                <div class="input-field my-0" v-if="unassigneds.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div v-if="parent.associate_signature === null" class="col-auto flex-grow-1 py-0 d-flex justify-content-between align-items-center duties">
            <button class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="unassigneds.length">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="unassigneds"
                                :search="search"
                                :updateable="true"
                                :checkable="true"
                                @emitToUpdate="modal_update($event)"
                                
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

      <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Unassigned Work'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :content_header="content_header"
            :rest_api="rest_api_child"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
        />

        <UpdateModal 
            :title="'Unassigned Work Update'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :content_header="content_header"
            :rest_api="rest_api_child"
            :notifications="notifications"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
        />

        <WaitingModal/>
    </section>
</template>

<script>
import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './detail_resources'
import FormModal        from    './FormModal'
import UpdateModal      from    './UpdateModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import DinamicTable     from    '@/components/DinamicTable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'WorksheetDetail',

    components: {
      Breadcrumb,
      WaitingModal,
      DeletionMassiveModal,
      FormModal,
      UpdateModal,
      DinamicTable
    },

    data() {
        return {
            notyf,
            axios,
            tracking_id:            this.$route.params.id,
            parent:                 {},
            parent_id:              '',
            title_page:             'Unassigned Works',
            content_header:         this.$store.state.headers,
            rest_api:               `worksheets/${this.$route.params.id}`,
            rest_api_child:         `unassigned_works`,
            notifications:          this.$store.state.form_notyf,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Unassigned Works',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           undefined,
            single_object:          {},
            unassigneds:            [],
            array_options:          {},
            select_ids:            [],
            // date:                   ''
        }
    },

    methods: {

       unshift_object(new_object){
            this.unassigneds.unshift(new_object)
        },

        splice_object(splicing_object){
            this.unassigneds.splice(splicing_object.index, 1, splicing_object.single_object)
        },

        form_modal(){
            window.$('#static').modal('show')
        },

        modal_update(index){
            this.global_index  = index
            this.single_object = this.unassigneds[index]
            this.single_object.updated_date = this.date;
            
            window.$('#static-update').modal('show')
        },
        fill_data(data) {
            this.parent      = data.worksheet
            this.parent_id   = data.parent_id
            this.unassigneds  = data.unassignmed_works
            this.breadcrumb.push({
                name:   this.parent.description,
                href:   '#',
                arrow:  "",
            })
        },

        massive_modal_delete()
        {
            this.select_ids = this.unassigneds.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete({ ids: this.select_ids }, this.rest_api_child)

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.unassigneds.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.unassigneds.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        trashing(index) {
            this.unassigneds.splice(index, 1)
        }
    },

    async mounted() {
        if(this.hasPermissions(['Census-Worksheet Read']))
        {
            await this.api_request()
        }
    },

    computed:
    {
         selected()
        {
            const bool = this.unassigneds.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}

</script>